export default "__VITE_ASSET__e8e0a3fe__"